import React from 'react';
import Skeleton from 'wsm-skeleton';

/**
 * Skeleton placeholder for a single location tile.
 * Mirrors the anatomy of wsm-tiles LocationTile (media variant):
 *   - tile-media  → 4by3 image skeleton
 *   - tile-body   → name, address, distance, open/close status
 *
 * Uses wsm-skeleton — same pattern as ws-inv-listing vehicle cards.
 */
const LocationTileSkeleton = () => (
	<div className="tile" data-testid="location-tile-skeleton">
		{/* Image area — matches tile-media 4:3 aspect ratio */}
		<div className="tile-media">
			<Skeleton aspectRatio="4by3" dataTestId="skeleton-media" />
		</div>

		{/* Body — matches tile-body spacing */}
		<div className="tile-body ddc-font-size-small">
			{/* Name / title */}
			<Skeleton
				skeletonClasses="mt-0 mb-3"
				height="1.5rem"
				width="75%"
				dataTestId="skeleton-name"
			/>
			{/* City, ST */}
			<Skeleton
				skeletonClasses="mb-2"
				height="1rem"
				width="55%"
				dataTestId="skeleton-address"
			/>
			{/* Distance */}
			<Skeleton
				skeletonClasses="mb-2"
				height="1rem"
				width="40%"
				dataTestId="skeleton-distance"
			/>
			{/* Open/Closed status */}
			<Skeleton height="1rem" width="50%" dataTestId="skeleton-status" />
		</div>
	</div>
);

export default LocationTileSkeleton;
